"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "NumberedList", {
    enumerable: true,
    get: function() {
        return NumberedList;
    }
});
var _react = _interop_require_wildcard(require("react"));
var _reactutils = require("@chakra-ui/react-utils");
var _components = require("../..");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var NumberedList = function(_param) {
    var children = _param.children, number = _param.number, props = _object_without_properties(_param, [
        "children",
        "number"
    ]);
    var validChildren = (0, _reactutils.getValidChildren)(children);
    return _react.default.createElement(_components.Flex, _object_spread_props(_object_spread({
        as: "ol"
    }, props), {
        direction: "column",
        gap: number ? "0.75rem" : "1rem"
    }), validChildren.map(function(listItem, index) {
        index++;
        return (0, _react.cloneElement)(listItem, {
            pl: number ? "0" : "0.5rem",
            key: index,
            number: number ? "".concat(number, ".").concat(index) : "".concat(index)
        });
    }));
};
var NumberedListItem = function(_param) {
    var _param_indexTextVariants = _param.indexTextVariants, indexTextVariants = _param_indexTextVariants === void 0 ? "text-body-regular" : _param_indexTextVariants, number = _param.number, children = _param.children, props = _object_without_properties(_param, [
        "indexTextVariants",
        "number",
        "children"
    ]);
    return _react.default.createElement(_components.Flex, _object_spread_props(_object_spread({
        as: "li",
        direction: "row",
        alignItems: "start"
    }, props), {
        gap: "0.25rem"
    }), _react.default.createElement(_components.Box, null, _react.default.createElement(_components.Text, {
        variant: indexTextVariants
    }, number, ".")), _react.default.createElement(_components.Box, null, _react.Children.map(children, function(child) {
        if ((0, _react.isValidElement)(child) && child.type === NumberedList) {
            return (0, _react.cloneElement)(child, {
                number: number,
                paddingTop: "0.75rem"
            });
        } else return child;
    })));
};
NumberedList.Item = NumberedListItem;
